module.exports = __webpack_public_path__ + "img/home-dashboard.feee990c.png";